import { format } from "date-fns";
import { CalculoPagoJudicial } from "../../../functions/Validaciones/PagoJudicial";
import { FormatterNumber } from "../../../utils/formatter";
import "../../shared/styles/UnifiedTable.css";

const Tabla_judiciales = ({
  data, onClick, onChange
}) => {

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  return (
    <div className="unified-table-container" style={{ maxHeight: "600px", overflowY: "auto" }}>
      <table className="unified-table">
        <thead>
          <tr style={{ background: '#f9fafb' }}>
            <th className="text-center" style={{ borderBottom: 'none', padding: '4px 6px' }}></th>
            <th className="text-center" colSpan="5" style={{
              borderBottom: 'none',
              padding: '4px 6px'
            }}>
              <div style={{
                background: 'linear-gradient(90deg, #fef3c7 0%, #fde68a 100%)',
                padding: '8px',
                borderRadius: '8px',
                border: '1px solid #fcd34d'
              }}>
                <small style={{ fontWeight: '600', color: '#92400e', fontSize: '11px', letterSpacing: '0.5px' }}>INFORMACIÓN DEL GASTO</small>
              </div>
            </th>
            <th className="text-center" colSpan="3" style={{
              borderBottom: 'none',
              padding: '4px 6px'
            }}>
              <div style={{
                background: 'linear-gradient(90deg, #fee2e2 0%, #fecaca 100%)',
                padding: '8px',
                borderRadius: '8px',
                border: '1px solid #fca5a5'
              }}>
                <small style={{ fontWeight: '600', color: '#991b1b', fontSize: '11px', letterSpacing: '0.5px' }}>CÁLCULO DE DEUDA</small>
              </div>
            </th>
            <th className="text-center" style={{ borderBottom: 'none', padding: '4px 6px' }} colSpan="2"></th>
          </tr>
          <tr>
            <th className="text-center"><div>Nº</div></th>
            <th className="text-start"><div>Detalle</div></th>
            <th className="text-center"><div>Vencimiento</div></th>
            <th className="text-center"><div>Fecha Actual</div></th>
            <th className="text-center"><div>Tasa Mensual</div></th>
            <th className="text-end"><div>Monto</div></th>
            <th className="text-center"><div>Días Mora</div></th>
            <th className="text-end"><div>Interés Mora</div></th>
            <th className="text-end"><div>Deuda Total</div></th>
            <th className="text-center"><div>Resumen</div></th>
            <th className="text-center"><div>Pagar</div></th>
          </tr>
        </thead>
        <tbody>
          {
            data.map((j, index) => (
            <tr key={j.id}>
              <td className="text-center">{j.id}</td>
              <td className="text-start">{j.item}</td>
              <td className="text-center">
                {format(new Date(j.fecha_otorgamiento+" 00:00:00"), 'dd/MM/yyyy')}
              </td>
              <td className="text-center">
                {format(new Date(), 'dd/MM/yyyy')}
              </td>
              <td className="text-center">
                {j.interes_moratorio}%
              </td>
              <td className="text-end">
                <span className="unified-money">
                  $ {formatCurrency(j.monto)}
                </span>
              </td>
              <td className="text-center">
                {CalculoPagoJudicial(j).diferencia} días
              </td>
              <td className="text-end">
                <span className="unified-money" style={{ color: '#ef4444' }}>
                  $ {formatCurrency(CalculoPagoJudicial(j).interes)}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money" style={{ fontWeight: '700', color: '#dc2626', fontSize: '15px' }}>
                  $ {CalculoPagoJudicial(j).deuda < 1 ? '0,00' : formatCurrency(CalculoPagoJudicial(j).deuda)}
                </span>
              </td>
              <td className="text-center">
                <button
                  className="btn btn-sm"
                  style={{
                    background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
                    color: '#ffffff',
                    borderRadius: '8px',
                    padding: '8px 16px',
                    border: 'none',
                    fontWeight: '500'
                  }}
                  name="resumen-judicial"
                  data-bs-toggle="modal"
                  data-bs-target="#resumen-gastos"
                  onClick={(event) => onClick(event, j)}
                >
                  <i className="bi bi-card-checklist me-2"></i>
                  Resumen
                </button>
              </td>
              <td className="text-center">
                <button
                  className="btn btn-sm"
                  style={{
                    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                    color: '#ffffff',
                    borderRadius: '8px',
                    padding: '8px 16px',
                    border: 'none',
                    fontWeight: '500'
                  }}
                  name="pagar-juidicial"
                  onClick={(event) => onClick(event, j)}
                >
                  <i className="bi bi-cash-coin me-2"></i>
                  Pagar
                </button>
              </td>
            </tr>
            ))
          }
          
        </tbody>
        <tfoot></tfoot>
      </table>
    </div>
  );
}

export default Tabla_judiciales;